import { defineComponent as _defineComponent } from 'vue';
import { DropdownMenuItem } from 'reka-ui';
import { cn } from '../utils';
export default /*@__PURE__*/ _defineComponent({
    ...{ inheritAttrs: false },
    __name: 'MenuItem',
    props: {
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true },
        disabled: { type: Boolean, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = { props, get DropdownMenuItem() { return DropdownMenuItem; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
